<div class="indicators-page">
    <!-- Page Header -->
    <div class="page-header">
        <div class="header-left">
            <div class="back-btn" [routerLink]="['/strategy']">
                @if(dir=='rtl'){
                <i class="pi pi-angle-right"></i>
                }@else {
                <i class="pi pi-angle-left"></i>
                }
            </div>
            <h1 class="page-title">{{ 'StrategicIndicators' | navTitle | async }}</h1>
        </div>
        
        @if(user.strategy_admin){
        <button class="btn-new-indicator" [routerLink]="['/strategies',selectedStrategyId,'indicators',0]">
            <i class="fa-solid fa-plus"></i>
            <span>{{'new_indicator'|translate}}</span>
        </button>
        }
    </div>

    <!-- Toolbar: Search, Goal & View Toggle -->
    <div class="toolbar-section">
        <!-- Goal Dropdown -->
        <div class="goal-filter">
            @if(goals && goals.length){
            <label class="filter-label">{{'goal'|translate}}</label>
            <p-dropdown 
                styleClass="goal-dropdown" 
                [(ngModel)]="selectedGoalId"
                (onChange)="selectGoalFn(selectedGoalId)"
                [options]="goalsOptions" 
                optionLabel="name" 
                optionValue="id" 
                placeholder="{{'select_goal'|translate}}" />
            }@else{
            <div class="empty-message-small">
                <i class="fa-solid fa-circle-exclamation"></i>
                <span>{{'no_goals'|translate}}</span>
            </div>
            }
        </div>
        
        <div class="search-wrapper">
            <i class="fa-solid fa-magnifying-glass search-icon"></i>
            <input 
                type="text" 
                class="search-input"
                [(ngModel)]="searchTerm" 
                placeholder="{{'search_by_indicator_name_or_supervisor_name'|translate}}" />
        </div>
        
        <!-- View Toggle Buttons -->
        <div class="view-toggles">
            <button class="view-btn" 
                    [class.active]="displayType === 'cards'"
                    (click)="displayType='cards'">
                <i class="pi pi-th-large"></i>
                <span>{{'cards_view' | translate}}</span>
            </button>
            <button class="view-btn" 
                    [class.active]="displayType === 'list'"
                    (click)="displayType='list'">
                <i class="pi pi-list"></i>
                <span>{{'list_view' | translate}}</span>
            </button>
        </div>
    </div>

    <!-- Content Area -->
    @if(filterdIndicators && filterdIndicators.length){
        <!-- Debug Info -->
        <div class="mb-2 text-sm text-gray-600">
            <i class="fa-solid fa-info-circle"></i>
            {{'total'|translate}}: {{filterdIndicators.length}} {{'indicators'|translate}}
        </div>
        
        <!-- Table View -->
        @if(displayType === 'list'){
            <div class="table-container">
                <p-table [value]="filterdIndicators" 
                         styleClass="indicators-table-modern"
                         [paginator]="true" 
                         [rows]="10"
                         [showCurrentPageReport]="true"
                         currentPageReportTemplate="{first} - {last} {{'of'|translate}} {totalRecords}"
                         [rowsPerPageOptions]="[10, 25, 50]">
                    <ng-template pTemplate="header">
                        <tr>
                            <th class="col-name">{{'name'|translate}}</th>
                            <th class="col-goal text-center">{{'goal'|translate}}</th>
                            <th class="col-cycle text-center">{{'measurement_cycle'|translate}}</th>
                            <th class="col-target text-center">{{'target'|translate}}</th>
                            <th class="col-actions text-center">{{'actions'|translate}}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-indicator let-i="rowIndex">
                        <tr>
                            <td class="col-name">
                                <div class="indicator-name-wrapper">
                                    <i class="indicator-icon fa-solid fa-chart-line"></i>
                                    <span>{{indicator.name}}</span>
                                </div>
                            </td>
                            <td class="col-goal">
                                <span class="goal-code-badge">
                                    <i class="fa-solid fa-bullseye"></i>
                                    {{indicator.goal_code || 'N/A'}}
                                </span>
                            </td>
                            <td class="col-cycle">
                                <span class="cycle-badge">
                                    <i class="fa-solid fa-repeat"></i>
                                    {{indicator.measurement_cycle_ar}}
                                </span>
                            </td>
                            <td class="col-target">
                                @if(hasQuarterTargets(indicator.target)){
                                <div class="quarters-inline">
                                    @for(q of parseTargetQuarters(indicator.target); track q.key){
                                    <span class="quarter-chip">
                                        <span class="quarter-chip__label">{{q.label}}</span>
                                        <span class="quarter-chip__value">{{q.value}}</span>
                                    </span>
                                    }
                                </div>
                                }@else{
                                <span class="target-badge">
                                    <i class="fa-solid fa-bullseye"></i>
                                    {{formatSimpleTarget(indicator)}}
                                </span>
                                }
                            </td>
                            <td class="col-actions">
                                <div class="action-buttons">
                                    <button class="action-btn view-btn" (click)="showIndicatorDetails(indicator)">
                                        <i class="far fa-eye"></i>
                                    </button>
                                    @if('manage' | able: 'Indicator':user){
                                    <button class="action-btn edit-btn" [routerLink]="['/strategies',selectedStrategyId,'indicators',indicator.id]">
                                        <i class="fa-solid fa-pencil"></i>
                                    </button>
                                    <button class="action-btn delete-btn" (click)="confirmIndicatorDelete($event, indicator.id)">
                                        <i class="far fa-trash-can"></i>
                                    </button>
                                    }
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        }
        
        <!-- Cards View -->
        @if(displayType === 'cards'){
            <div class="indicators-grid" (click)="closeMenu()">
                @for(indicator of filterdIndicators; track indicator; let i = $index){
                <div class="indicator-card-wrapper">
                    <article class="indicator-card" (click)="$event.stopPropagation()">
                        <div class="indicator-header">
                            <div class="header-left">
                                <span class="indicator-number">{{i + 1}}</span>
                                <span class="goal-code">{{indicator.goal_code || 'N/A'}}</span>
                            </div>
                            
                            @if('manage' | able: 'Indicator':user){
                            <button class="menu-trigger" (click)="toggleMenu($event, indicator.id)">
                                <i class="fa-solid fa-ellipsis-vertical"></i>
                            </button>
                            @if(activeMenuId === indicator.id){
                            <div class="menu-dropdown" (click)="$event.stopPropagation()">
                                <div class="menu-item view" (click)="showIndicatorDetails(indicator); closeMenu()">
                                    <i class="far fa-eye"></i>
                                    <span>{{'view'|translate}}</span>
                                </div>
                                <div class="menu-item edit" [routerLink]="['/strategies',selectedStrategyId,'indicators',indicator.id]" (click)="closeMenu()">
                                    <i class="fa-solid fa-pen"></i>
                                    <span>{{'edit'|translate}}</span>
                                </div>
                                <div class="menu-item delete" (click)="confirmIndicatorDelete($event, indicator.id); closeMenu()">
                                    <i class="fa-regular fa-trash-can"></i>
                                    <span>{{'delete'|translate}}</span>
                                </div>
                            </div>
                            }
                            }
                        </div>
                        
                        <h3 class="indicator-title">{{indicator.name}}</h3>
                        
                        <div class="indicator-stats">
                            <button type="button" class="stat-btn stat-cycle">
                                <i class="fa-solid fa-repeat"></i>
                                <span>{{indicator.measurement_cycle_ar}}</span>
                            </button>
                            @if(!hasQuarterTargets(indicator.target)){
                            <button type="button" class="stat-btn stat-target">
                                <i class="fa-solid fa-bullseye"></i>
                                <span>{{formatSimpleTarget(indicator)}}</span>
                            </button>
                            }
                        </div>

                        @if(hasQuarterTargets(indicator.target)){
                        <div class="quarters-panel">
                            <div class="quarters-panel__head">
                                <i class="fa-solid fa-bullseye"></i>
                                <span>{{'target'|translate}}</span>
                            </div>
                            <div class="quarters-grid">
                                @for(q of parseTargetQuarters(indicator.target); track q.key){
                                <div class="quarter-cell" [attr.data-quarter]="q.key">
                                    <span class="quarter-cell__label">{{q.label}}</span>
                                    <span class="quarter-cell__value">{{q.value}}</span>
                                </div>
                                }
                            </div>
                        </div>
                        }
                    </article>
                </div>
                }
            </div>
        }
    }@else{
        <div class="empty-state">
            <i class="pi pi-inbox"></i>
            <p>{{'there are no indicators'|translate}}</p>
        </div>
    }

    <!-- Confirm Popup -->
    <p-confirmPopup #confirmPopupRef>
        <ng-template pTemplate="headless" let-message>
            <div class="border-round p-3">
                <span>{{ message.message }}</span>
                <div class="flex align-items-center gap-2 mt-3">
                    <p-button (click)="accept()" label="{{'yes'|translate}}" severity="danger"></p-button>
                    <p-button (click)="reject()" label="{{'no'|translate}}" severity="secondary"></p-button>
                </div>
            </div>
        </ng-template>
    </p-confirmPopup>

</div>

<!-- Indicator Details Modal -->
@if(isViewDetailsModal && selectedViewIndicator) {
<div class="modal-wrapper">
    <div class="g-overlay" (click)="closeDetailsModal()"></div>
    <div class="g-modal details-modal">
        <div class="modal-header">
            <h2 class="modal-title">{{'indicator'|translate}} - {{selectedViewIndicator.name}}</h2>
            <button class="close-btn" (click)="closeDetailsModal()">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>
        <div class="modal__body">
            <div class="details-grid">
                <!-- Name -->
                <div class="detail-item name-item">
                    <label class="detail-label">{{'name'|translate}}</label>
                    <p class="detail-value">{{selectedViewIndicator.name}}</p>
                </div>
                
                <!-- Code -->
                <div class="detail-item">
                    <label class="detail-label">{{'code'|translate}}</label>
                    <p class="detail-value">{{selectedViewIndicator.code}}</p>
                </div>
                
                <!-- Target -->
                <div class="detail-item" [class.full-width]="hasQuarterTargets(selectedViewIndicator.target)">
                    <label class="detail-label">{{'target'|translate}}</label>
                    @if(hasQuarterTargets(selectedViewIndicator.target)){
                    <div class="quarters-panel quarters-panel--details">
                        <div class="quarters-grid">
                            @for(q of parseTargetQuarters(selectedViewIndicator.target); track q.key){
                            <div class="quarter-cell" [attr.data-quarter]="q.key">
                                <span class="quarter-cell__label">{{q.label}}</span>
                                <span class="quarter-cell__value">{{q.value}}</span>
                            </div>
                            }
                        </div>
                    </div>
                    }@else{
                    <p class="detail-value">{{formatSimpleTarget(selectedViewIndicator)}}</p>
                    }
                </div>
                
                <!-- Description -->
                @if(selectedViewIndicator.description){
                <div class="detail-item full-width">
                    <label class="detail-label">{{'description'|translate}}</label>
                    <p class="detail-value description">{{selectedViewIndicator.description}}</p>
                </div>
                }
            </div>
        </div>
    </div>
</div>
}
